import { z } from "zod";

export const CrewEquipmentAssignmentSchema = z.object({
  id: z.string().uuid().describe("ID"),
  business_id: z.string().uuid().describe("Business"),
  account_id: z.string().uuid().describe("Account"),
  crew_id: z.string().uuid().describe("Crew"),
  equipment_asset_id: z.string().uuid().describe("Equipment Asset"),
  assigned_at: z.string().describe("Assigned At"),
  returned_at: z.string().nullable().describe("Returned At"),
  notes: z.string().nullable().describe("Notes"),
  created_at: z.string().describe("Created At"),
  updated_at: z.string().describe("Updated At"),
});
export type CrewEquipmentAssignment = z.infer<
  typeof CrewEquipmentAssignmentSchema
>;
